import { useCallback, useRef } from 'react';
import { useBettieProfileImageOverlay } from '../../chat/hooks/useBettieProfileImageOverlay';
import { useUpdateCastRelationship } from '../../../domains/scene/ui/hooks/useUpdateCastRelationship';

export function useUpdateCastRelationshipImage(castRelationshipId: string | undefined) {
  const currentSlotRef = useRef<'a' | 'b'>('a');
  const { mutate: updateCastRelationship, isLoading: isUpdating } = useUpdateCastRelationship();

  const { openImagePicker, fileInputProps, overlayProps } = useBettieProfileImageOverlay({
    onConfirm: ({ dataUrl }) => {
      if (!castRelationshipId) return;
      const slot = currentSlotRef.current;
      updateCastRelationship({
        castRelationshipId,
        body: {
          cast_relationship:
            slot === 'a'
              ? { member_a: { data_url: dataUrl } }
              : { member_b: { data_url: dataUrl } }
        }
      });
    }
  });

  const handlePersonAClick = useCallback(() => {
    currentSlotRef.current = 'a';
    openImagePicker();
  }, [openImagePicker]);

  const handlePersonBClick = useCallback(() => {
    currentSlotRef.current = 'b';
    openImagePicker();
  }, [openImagePicker]);

  return {
    handlePersonAClick,
    handlePersonBClick,
    fileInputProps,
    overlayProps,
    isUpdating
  };
}
